/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_Type_ProductInputs */

const vi_warehouse_position_type_product = /** @type {(inputs: Warehouse_Position_Type_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô hàng bán`)
};

/**

* @param {Warehouse_Position_Type_ProductInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_type_product = /** @type {((inputs?: Warehouse_Position_Type_ProductInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_Type_ProductInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_type_product(inputs)
});